import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminNav from '../components/AdminNav';

const s = {
  page: { minHeight: '100vh', background: '#f8f8f6', padding: '0' },
  nav: {
    background: '#111', color: '#fff', padding: '0 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: '56px',
  },
  content: { maxWidth: '960px', margin: '0 auto', padding: '40px 16px' },
  heading: { fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '8px' },
  sub: { fontSize: '14px', color: '#666', marginBottom: '32px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '40px' },
  statCard: {
    background: '#fff', borderRadius: '10px',
    boxShadow: '0 1px 8px rgba(0,0,0,0.07)',
    padding: '24px 20px',
  },
  statValue: { fontSize: '32px', fontWeight: '800', color: '#111', marginBottom: '4px' },
  statLabel: { fontSize: '13px', color: '#888', fontWeight: '500' },
  quickLinks: { display: 'flex', gap: '12px', flexWrap: 'wrap' },
  linkCard: {
    background: '#fff', borderRadius: '10px',
    boxShadow: '0 1px 8px rgba(0,0,0,0.07)',
    padding: '20px 24px',
    textDecoration: 'none', color: '#111',
    fontWeight: '600', fontSize: '14px',
    border: '1.5px solid transparent',
    transition: 'border-color 0.15s',
  },
};

function StatCard({ value, label }) {
  return (
    <div style={s.statCard}>
      <div style={s.statValue}>{value ?? '—'}</div>
      <div style={s.statLabel}>{label}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const username = localStorage.getItem('username');
  const role = localStorage.getItem('role');

  useEffect(() => {
    fetch('/api/admin/dashboard', { credentials: 'include' })
      .then((r) => r.json())
      .then(setStats)
      .catch(console.error);
  }, []);

  return (
    <div style={s.page}>
      <AdminNav />

      <div style={s.content}>
        <div style={s.heading}>Dashboard</div>
        <div style={s.sub}>Overview of all certificates in the system. Welcome back, {username}.</div>

        <div style={s.grid}>
          <StatCard value={stats?.totalCerts?.toLocaleString()} label="Total Certificates" />
          <StatCard value={stats?.totalAssigned?.toLocaleString()} label="Assigned" />
          <StatCard value={stats?.totalUnassigned?.toLocaleString()} label="Unassigned" />
          <StatCard value={stats?.totalBatches?.toLocaleString()} label="Batches" />
        </div>

        <div style={{ fontSize: '15px', fontWeight: '600', color: '#444', marginBottom: '14px' }}>Quick Links</div>
        <div style={s.quickLinks}>
          <Link to="/admin/batches" style={s.linkCard}>Batch Manager →</Link>
          <Link to="/admin/assign" style={s.linkCard}>Range Assignment →</Link>
          {role === 'dev' && <Link to="/admin/users" style={s.linkCard}>User Manager →</Link>}
          {role === 'dev' && <Link to="/admin/history" style={s.linkCard}>Action History →</Link>}
          <Link to="/admin/settings" style={s.linkCard}>Settings →</Link>
          <Link to="/verify" style={s.linkCard} target="_blank" rel="noopener noreferrer">Public Verify →</Link>
        </div>
      </div>
    </div>
  );
}
